import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IBackgroundJobParams, IExecution } from '../types/IExecution';

/** The VizPortal `cancelExecution` Web Client method (CM `cancelJob`) for a background job id. */
export class CancelExecutionRequest extends Request<IBackgroundJobParams, IExecution> {
  constructor(params: IBackgroundJobParams) {
    super('cancelExecution', params);
  }
}
